import React from 'react';
import { useNavigate } from 'react-router-dom';

function PropFirmResults() {
  const navigate = useNavigate();

  const stats = {
    startBalance: 100000,
    finalBalance: 105127.25,
    profit: 5127.25,
    profitPercent: 5.1,
    winRate: 83.33,
    totalTrades: 12,
    winningTrades: 10,
    losingTrades: 2,
    bestDay: 2229.02,
    worstDay: -3813.38,
    avgDailyProfit: 569.69,
    tradingDays: 9,
    accountSize: 100000,
    accountType: 'FTMO Challenge',
    status: 'PASSED',
    startDate: '23 Oct 2025',
    endDate: '6 Nov 2025',
    verificationLink: 'https://trader.ftmo.com/live-metrix/1511857119/share/019a115c-5860-73c3-a78b-22614390b044?lang=en'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-emerald-600 border-b border-green-500 shadow-2xl">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <button 
            onClick={() => navigate('/')}
            className="text-sm text-white/80 hover:text-white mb-4 flex items-center gap-2 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </button>
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-white mb-2">FTMO Challenge Results</h1>
              <p className="text-white/90 text-lg">Kasango AI Pro - Live Prop Firm Performance</p>
            </div>
            <div className="text-right">
              <div className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm border-2 border-white px-6 py-3 rounded-xl">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <div>
                  <div className="text-sm text-white/80">Status</div>
                  <div className="text-xl font-bold text-white">{stats.status}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        
        {/* Overview Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Starting Balance */}
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 border border-gray-700 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="text-sm text-gray-400 mb-1">Starting Balance</div>
            <div className="text-3xl font-bold text-white">${stats.startBalance.toLocaleString()}</div>
          </div>

          {/* Final Balance */}
          <div className="bg-gradient-to-br from-green-900 to-emerald-900 rounded-2xl p-6 border border-green-600 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center">
                <svg className="w-6 h-6 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="text-sm text-green-300 mb-1">Final Balance</div>
            <div className="text-3xl font-bold text-white">${stats.finalBalance.toLocaleString()}</div>
          </div>

          {/* Total Profit */}
          <div className="bg-gradient-to-br from-emerald-900 to-green-900 rounded-2xl p-6 border border-emerald-500 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                <svg className="w-6 h-6 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="text-sm text-emerald-300 mb-1">Total Profit</div>
            <div className="text-3xl font-bold text-white">+${stats.profit.toLocaleString()}</div>
            <div className="text-lg text-emerald-400 mt-1">+{stats.profitPercent}%</div>
          </div>

          {/* Win Rate */}
          <div className="bg-gradient-to-br from-purple-900 to-indigo-900 rounded-2xl p-6 border border-purple-600 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-purple-500/20 flex items-center justify-center">
                <svg className="w-6 h-6 text-purple-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                </svg>
              </div>
            </div>
            <div className="text-sm text-purple-300 mb-1">Win Rate</div>
            <div className="text-3xl font-bold text-white">{stats.winRate}%</div>
            <div className="text-sm text-purple-400 mt-1">{stats.winningTrades}/{stats.totalTrades} trades</div>
          </div>
        </div>

        {/* Detailed Stats */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          
          {/* Trading Performance */}
          <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 shadow-xl">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
              <svg className="w-6 h-6 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
              </svg>
              Trading Performance
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Total Trades</span>
                <span className="text-white font-bold text-lg">{stats.totalTrades}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Winning Trades</span>
                <span className="text-green-400 font-bold text-lg">{stats.winningTrades}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Losing Trades</span>
                <span className="text-red-400 font-bold text-lg">{stats.losingTrades}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Best Day</span>
                <span className="text-green-400 font-bold text-lg">+${stats.bestDay.toLocaleString()}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Worst Day</span>
                <span className="text-red-400 font-bold text-lg">${stats.worstDay.toLocaleString()}</span>
              </div>
              <div className="flex items-center justify-between py-3">
                <span className="text-gray-400">Avg Daily Profit</span>
                <span className="text-white font-bold text-lg">${stats.avgDailyProfit.toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Account Info */}
          <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 shadow-xl">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
              <svg className="w-6 h-6 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              Account Information
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Account Type</span>
                <span className="text-white font-bold">{stats.accountType}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Account Size</span>
                <span className="text-white font-bold">${stats.accountSize.toLocaleString()}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Trading Days</span>
                <span className="text-white font-bold">{stats.tradingDays} days</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">Start Date</span>
                <span className="text-white font-bold">{stats.startDate}</span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-700">
                <span className="text-gray-400">End Date</span>
                <span className="text-white font-bold">{stats.endDate}</span>
              </div>
              <div className="flex items-center justify-between py-3">
                <span className="text-gray-400">Status</span>
                <span className="inline-flex items-center gap-2 px-3 py-1 bg-green-500/20 text-green-400 rounded-full font-bold">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  {stats.status}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* FTMO Verification */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 border border-blue-500 shadow-2xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold text-white mb-2">Verify These Results on FTMO</h3>
              <p className="text-white/90">
                Click below to view the official FTMO MetriX dashboard and verify all trading data
              </p>
            </div>
            <a
              href={stats.verificationLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white hover:bg-gray-100 text-blue-600 font-bold text-lg rounded-xl transition-all hover:scale-105 shadow-xl whitespace-nowrap"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
              </svg>
              View Full FTMO Report
            </a>
          </div>
        </div>

        {/* Screenshots */}
        <div className="mt-12">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">Official FTMO Screenshots</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 rounded-2xl p-4 border border-gray-700 shadow-xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_tradewise-demo/artifacts/2mfevc0h_Screenshot%202026-01-16%20042330.png"
                alt="FTMO Trading Stats"
                className="w-full rounded-xl"
              />
              <p className="text-gray-400 text-sm text-center mt-3">Trading Statistics & Daily Summary</p>
            </div>
            <div className="bg-gray-800 rounded-2xl p-4 border border-gray-700 shadow-xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_tradewise-demo/artifacts/0zv9m69x_Screenshot%202026-01-16%20042339.png"
                alt="FTMO Account MetriX"
                className="w-full rounded-xl"
              />
              <p className="text-gray-400 text-sm text-center mt-3">Account MetriX & Equity Curve</p>
            </div>
          </div>
        </div>

      </div>

      {/* Footer CTA */}
      <div className="bg-gradient-to-r from-green-600 to-emerald-600 py-12 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Want Results Like This?
          </h3>
          <p className="text-white/90 text-lg mb-6">
            Get Kasango AI Pro and let the same AI engine trade for you
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://whop.com/checkout/plan_2ekgQsmNUX0es?d2c=true"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white hover:bg-gray-100 text-green-600 font-bold rounded-xl transition-all hover:scale-105 shadow-xl"
            >
              Get Kasango AI Pro →
            </a>
            <a
              href="https://wa.me/27685358462?text=Hi%2C%20I%20want%20to%20learn%20more%20about%20Kasango%20AI%20Pro%20and%20prop%20firm%20trading"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-black/20 hover:bg-black/30 text-white font-bold rounded-xl transition-all hover:scale-105"
            >
              Chat with John
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropFirmResults;
